import { TimelineContent } from '@mui/lab';
import { Grid, Paper, Typography } from '@mui/material';
import { getDestinationContactFromOrderInfo, getRequesterContactFromOrderInfo, OrderInfoContact, TimelineStatus } from "adoms-common-lib";
import React from 'react';
import { timelineComponent } from '../molecule/OperationHistoryTimeline';

type FlightTimelineContentProps = {
    timelineComponent: timelineComponent
}

export const OperationHistoryTimelineContent: React.FC<FlightTimelineContentProps> = (props) => {
    let requesterName: OrderInfoContact
    let destinationName: OrderInfoContact

    if (props.timelineComponent.newOrderInfo) {
        requesterName = getRequesterContactFromOrderInfo(props.timelineComponent.newOrderInfo);
        destinationName = getDestinationContactFromOrderInfo(props.timelineComponent.newOrderInfo);
    };

    const timelineOperationUser = () => {
        if (props.timelineComponent.updateUserInfo?.name) {
            return <Typography>{props.timelineComponent.updateUserInfo?.name}</Typography>
        } else if (props.timelineComponent.status === TimelineStatus.Order_Received
        ) {
            if (destinationName?.lastname
                && destinationName?.firstname) {
                return <Typography>
                    {destinationName.lastname + " "
                        + destinationName.firstname + " 様"}</Typography>
            };
        } else if (props.timelineComponent.status === TimelineStatus.Order_NewOrder
            || props.timelineComponent.status === TimelineStatus.Order_DepartForPort) {
            if (requesterName?.lastname
                && requesterName?.firstname) {
                return <Typography>
                    {requesterName.lastname + " "
                        + requesterName.firstname + " 様"}</Typography>
            };
        }
    };

    return (
        <TimelineContent>
            <Paper sx={{ wordBreak: "break-all", width: "200px" }} variant='outlined'>
                <Grid container spacing={1} direction="column" padding={1}>
                    <Grid item>
                        <Typography fontWeight="bold">{props.timelineComponent.operation}</Typography>
                    </Grid>
                    <Grid item>{timelineOperationUser()}</Grid>
                </Grid>
            </Paper>
        </TimelineContent>
    )
};